// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import ProjectsPage from "./pages/ProjectsPage";
import TimeWorkPage from "./pages/TimeWorkPage";
import AdminWorkersPage from "./pages/AdminWorkersPage";

// Small, safe token decoder (no external deps)
function getUserFromToken(token) {
  if (!token) return null;
  try {
    const base64 = token.split(".")[1];
    const payload = JSON.parse(atob(base64));
    return payload && typeof payload === "object" ? payload : null;
  } catch {
    return null;
  }
}

function App() {
  const token = localStorage.getItem("token");
  const user = getUserFromToken(token);
  const isAuthed = !!token && !!user;
  const isAdmin = isAuthed && user.role === "admin";

  return (
    <Router>
      <Routes>
        <Route path="/login" element={isAuthed ? <Navigate to="/" /> : <LoginPage />} />

        <Route path="/" element={isAuthed ? <HomePage isAdmin={isAdmin} /> : <Navigate to="/login" />} />

        {/* fullWidth applied here */}
        <Route
          path="/projects"
          element={isAuthed ? <ProjectsPage isAdmin={isAdmin} /> : <Navigate to="/login" />}
        />

        <Route path="/timework" element={isAuthed ? <TimeWorkPage isAdmin={isAdmin} /> : <Navigate to="/login" />} />
        <Route path="/time-entries" element={isAuthed ? <TimeWorkPage isAdmin={isAdmin} /> : <Navigate to="/login" />} />

        <Route
          path="/admin/workers"
          element={
            isAuthed
              ? (isAdmin ? <AdminWorkersPage isAdmin={isAdmin} /> : <Navigate to="/" />)
              : <Navigate to="/login" />
          }
        />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to={isAuthed ? "/" : "/login"} />} />
      </Routes>
    </Router>
  );
}

export default App;
